import { ExportControlLevel } from '@precheckin/models/export-control/export-control-level.enum';
import { cloneDeep } from 'lodash';

export interface IExportControlCitizenship {
  id: string;
  updatedAt: string;
  restrictionLevel: ExportControlLevel;
}

export class ExportControlCitizenship implements IExportControlCitizenship {
  id: string;
  updatedAt: string;
  restrictionLevel: ExportControlLevel;

  constructor(clone: ExportControlCitizenship = null) {
    this.id = '';
    this.updatedAt = null;
    this.restrictionLevel = null;

    if (clone) {
      this.id = cloneDeep(clone.id);
      this.updatedAt = cloneDeep(clone.updatedAt);
      this.restrictionLevel = cloneDeep(clone.restrictionLevel);
    }
  }
}
